import { checkMsgToInsert } from 'src/utils/chats.utils';

// Tipos que o checkMsgToInsert nao cobre (cai no default "" e a notificacao
// ficava sem corpo nenhum).
const EXTRA = {
  audio: '🎤 Áudio',
  multi_vcard: '👤 Contatos',
  order: '🛒 Pedido',
  product: '🛍️ Produto',
  poll_creation: '📊 Enquete',
  list: '📋 Lista',
  list_response: '↩️ Resposta',
  buttons_response: '↩️ Resposta',
  template_button_reply: '↩️ Resposta',
  template: '💬 Mensagem',
  interactive: '💬 Mensagem',
  reaction: '👍 Reação',
  revoked: '🚫 Mensagem apagada',
  ciphertext: '🔒 Mensagem',
  e2e_notification: '🔒 Mensagem',
};

/**
 * Corpo da notificacao para uma mensagem recebida.
 *
 * O `notifyNewMessage` antigo so montava notificacao para `chat`, `ptt` e
 * `image`: video, documento, sticker, localizacao e contato tocavam o som mas
 * nao mostravam nada na tela.
 */
export function rotuloMensagem(message) {
  if (!message) return 'Nova mensagem';

  if (!message.type || message.type === 'chat') {
    const texto = String(message.body || '').trim();
    return texto ? texto.slice(0, 180) : 'Nova mensagem';
  }

  return EXTRA[message.type] || checkMsgToInsert(message) || '💬 Nova mensagem';
}
